import { gql } from '@apollo/client';

export const MOVE_PART = gql`
  mutation movePart(
    $serialId: String!
    $source: MoveContainer!
    $destination: MoveContainer!
    $parentContainers: [MoveContainer]
    $login: String!
    $workflowId: String
  ) {
    movePart(
      serialId: $serialId
      source: $source
      destination: $destination
      parentContainers: $parentContainers
      login: $login
      workflowId: $workflowId
    ) {
      status
      messages
      serial_id
    }
  }
`;

export const BULK_MOVE_PARTS = gql`
  mutation bulkMoveParts($source: MoveContainer!, $destination: MoveContainer!, $login: String!) {
    bulkMoveParts(source: $source, destination: $destination, login: $login) {
      status
      messages
    }
  }
`;

export const GET_PARTS_IN_USER_CUSTODY = gql`
  query getPartsInUserCustody($userAlias: String!) {
    getPartsInUserCustody(userAlias: $userAlias) {
      parts {
        serial_id
        user_who_has_custody
        state
        model
      }
    }
  }
`;

export const GET_WORKFLOW_IDS = gql`
  query getWorkflows($sourceType: String!, $destinationType: String!) {
    getWorkflows(sourceType: $sourceType, destinationType: $destinationType) {
      workflows
    }
  }
`;

export const GET_BIN = gql`
  query getBin($containerId: String!) {
    getBin(containerId: $containerId) {
      id
      bin
      bin_type_id
      cms_id
    }
  }
`;

export const GET_TOTE = gql`
  query getTote($containerId: String!) {
    getTote(containerId: $containerId) {
      id
      tote_asset_id
      cms_id
    }
  }
`;

export const GET_PALLET = gql`
  query getPallet($containerId: String!) {
    getPallet(containerId: $containerId) {
      id
      pallet_asset_id
      cms_id
    }
  }
`;
